{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Дивитись усі варіанти",
  "Spoiler_Reveal_Tooltip": "Натисніть, щоб розкрити",
  "VerticalEmbed_Event_Error_Subtitle": "Цей захід видалено. Замініть його іншим.",
  "Viewer_Toolbar_Twitter_Tooltip": "Твітнути",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Елемент згорнуто",
  "Spoiler_Reveal_Video_CTA": "Розкрити відео",
  "VerticalEmbed_Pricing_Plan": "Тільки з планом",
  "Image_Expand_Button_AriaLabel": "Розгорнути зображення",
  "VerticalEmbed_From_Price": "Від",
  "Poll_Viewer_ShowAllResults_CTA": "Дивитись усі результати",
  "Spoiler_Reveal_Image_Placeholder": "На цьому зображенні є спойлер",
  "VerticalEmbed_Ribbon": "Знижка",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Слайдер гучності",
  "VerticalEmbed_Error_Subtitle": "Цю позицію видалено. Замініть її іншою.",
  "Poll_Viewer_Multiselect_Footer": "Ви можете проголосувати більше ніж за одну відповідь.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Показати більше елементів керування аудіо",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Не вдалося завантажити послугу",
  "Fullscreen_Close_Button_AriaLabel": "Закрити",
  "VerticalEmbed_Event_Fetch_Error_Title": "Не вдалося завантажити захід",
  "UploadFile_Viewer_Loader": "Завантаження {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Аватар користувача",
  "Preview_ReadMore_Label": "Читати далі",
  "Spoiler_Insert_Tooltip": "Спойлер",
  "VerticalEmbed_Product_Fetch_Error_Title": "Не вдалося завантажити товар",
  "Fullscreen_Shrink_Button_AriaLabel": "Стиснути",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Гучність",
  "Spoiler_Reveal_Gallery_Placeholder": "У цій галереї є спойлер",
  "Fullscreen_Expand_Button_AriaLabel": "Розгорнути",
  "VerticalEmbed_Bookings_Button": "Записатися",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Скасувати приглушення",
  "Spoiler_Reveal_Gallery_CTA": "Розкрити галерею",
  "Poll_Viewer_ShowLess_CTA": "Показати менше",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Приглушити",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "Анонімних гостей: +{{anonNumber}}",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Стежити",
  "VerticalEmbed_Products_Button": "Купити зараз",
  "Poll_Viewer_Toast_Error_ServerDown": "Немає зв'язку з сервером Повторіть спробу пізніше.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} людина проголосувала за цю відповідь",
  "Poll_Viewer_VoteCount": "Голосів: {{number}}",
  "VerticalEmbed_Events_Button": "Зареєструватися",
  "Spoiler_Reveal_Image_CTA": "Розкрити зображення",
  "Poll_Viewer_Toast_Error_Connection": "Відсутній інтернет. Перевірте з'єднання.",
  "Poll_Viewer_Visibility_Owner_Footer": "Результати бачите лише ви.",
  "VerticalEmbed_Booking_Error_Title": "Послугу видалено",
  "VerticalEmbed_Product_Error_Title": "Товар видалено",
  "VerticalEmbed_Fetch_Error_Subtitle": "Не вдається завантажити інформацію про позицію.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "Людей, які проголосували за цю відповідь: {{count}}",
  "VerticalEmbed_Event_Error_Title": "Захід видалено.",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Елемент розгорнуто",
  "Audio_Plugin_Cover_Alt": "Обкладинка аудіо",
  "Spoiler_Reveal_Video_Placeholder": "У цьому відео є спойлер",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Виникла технічна проблема. Перевірте з'єднання і спробуйте знову.",
  "VerticalEmbed_Fetch_Error_Title": "Не вдалося завантажити позицію",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Цей товар видалено. Замініть його іншим.",
  "VerticalEmbed_Booking_Error_Subtitle": "Цю послугу видалено. Замініть її іншою.",
  "Preview_SeeFullPost_Label": "Переглянути весь пост",
  "UploadFile_Viewer_Download": "Завантажити {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} год.",
  "VerticalEmbed_Units_Minute": "{{minutes}} хв.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Виникла технічна проблема. Перевірте з'єднання і спробуйте знову.",
  "VerticalEmbed_Error_Button": "Замінити",
  "VerticalEmbed_Error_Title": "Позицію видалено",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Виникла технічна проблема. Перевірте з'єднання і спробуйте знову.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
